import React, { useState, useEffect } from "react";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { customFormatOptions } from "../../../common/converters";
import { createNextYearAdmission, dueAmountAction } from "../../../redux/actions/studentActions";
import { PAYMENT } from "../../constants";
import { branchClassGroupLevelClassRoomsAction } from "../../../redux/actions/feesActions";

const AdmissionForward = (props) => {
  const { studentData, closeModal ,changeTab} = props;
  const dispatch = useDispatch();
  const { branchLevelDetails ,branchClassGroupLevelClassRooms } = useSelector((state) => state.fees);
  const { admissionForwardClassGroups,studentProfileDetails } = useSelector((state) => state.student);
  const [show, setShow] = useState(props.show);
  const [branchList, setBranchList] = useState([]);
  const [classGroupList, setClassGroupList] = useState([]);
  const [classRoomList, setClassRoomList] = useState([]);
  const [brancClassGroupData, setBrancClassGroupData] = useState({});

  const validationSchema = Yup.object().shape({
    name:Yup.string().required("Field is required "),
    email:Yup.string().required("Field is required "),
    BranchId: Yup.object().required("Branch Name is required").nullable(),
    ClassGroupName: Yup.string(),
    ClassRoomName: Yup.string(),
    academicStartDate: Yup.string().required("Start Date is Required"),
    academicEndDate: Yup.string().required("End Date is Required"),
    ClassGroupId: Yup.object()
      .required("Class Group Name is required")
      .nullable(),
    ClassRoomId: Yup.object()
    // .required("Class Room Name is required")
    .nullable(),
    courseFee: Yup.number().required("Field is required "),
    otherFee: Yup.string(),
    comment: Yup.string()
      .ensure()
      .when("otherFee", (otherFee) => {
        if(otherFee){
          return Yup.string().required("Must enter comment")
        }
          
      }),
  });

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      BranchId: {
        value: studentData.Branch.id,
        label: studentData.Branch.name,
      },
      ClassGroupName: studentData.ClassGroup.name,
      ClassRoomName: studentData.ClassRoom ? studentData.ClassRoom.name : null ,
      email: studentData.User.email,
      phoneNumber: studentData.User.phoneNumber,
      name: studentData.User.firstName + " " +  studentData.User.lastName, 
      courseFee: 0,
    },
    resolver: yupResolver(validationSchema),
  });

  const groupNameWatch = watch("ClassGroupId")
  useEffect(() => {
    onChangeGroupNameAction(groupNameWatch)
  }, [groupNameWatch]);

// useEffect(async() => {
//   await dispatch(dueAmountAction({
//     StudentFeeId: studentProfileDetails.StudentFeeId,
//     isRedirect:true
//   }))
// }, [studentProfileDetails])

  useEffect(() => {
    if (branchLevelDetails.length > 0) {
      setBranchList(
        branchLevelDetails.filter((obj) => {
          obj.label = obj.name;
          obj.value = obj.id;
          obj.disabled = true;
          setClassGroupList(
            obj.group_info.filter((groupObj) => {
              groupObj.label = groupObj.name;
              groupObj.value = groupObj.id;
              groupObj.disabled = groupObj.name === studentData.ClassGroup.name;
              return obj;
            })
          );
          return obj;
        })
      );
    }
  }, [branchLevelDetails]);
  const handleClose = () => {
    setShow(false);
    closeModal();
  };
  const handleShow = () => setShow(true);

  const onChangeGroupNameAction = async(groupData) => {
    if(groupData){
      setClassRoomList([]);
      groupData.fee = groupData.fee;
      await dispatch(branchClassGroupLevelClassRoomsAction({
        ClassGroupId: parseInt(groupData.value),
        BranchId: parseInt(studentData.BranchId),
        disabled: false
      }))
    // const classRoomData = branchClassGroupLevelDetails.filter(obj=> obj.id === groupData.id);
    // if(classRoomData.length > 0 ){
    //   setClassRoomList(customFormatOptions(classRoomData[0]['branch_classgroup_classroom_info'],'id','name'))
    // }else{
    //   setClassRoomList([]);
    // }
    setValue("courseFee", groupData.fee);
    setBrancClassGroupData(groupData);
    clearErrors("ClassGroupId")
    }else{
      setValue("courseFee", 0);
      setBrancClassGroupData([])
      setValue("ClassRoomId",[])
      setClassRoomList([])
    }
  };
  const onSubmit = async (reqData) => {
    const reqParams = {
      BranchId: reqData.BranchId.value,
      BranchClassGroupId: reqData.ClassGroupId.BranchClassGroupId,
      ClassGroupId: reqData.ClassGroupId.value,
      ClassRoomId: reqData.ClassRoomId ? reqData.ClassRoomId.value : null ,
      academicStartDate: reqData.academicStartDate,
      academicEndDate: reqData.academicEndDate,
      courseFee: reqData.courseFee,
      StudentId: studentData.id,
      otherFee : reqData.otherFee,
      comment: reqData.comment
    }
    await dispatch(createNextYearAdmission(reqParams));
    // // closeModal();
    changeTab(PAYMENT)
  };
  const onError = (errors, e) => console.log(errors, e);
  return (
    <>
      {/* <Modal show={show} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Admission Forward</Modal.Title>
        </Modal.Header> */}
        <Form noValidate onSubmit={handleSubmit(onSubmit,onError)}>
          {/* <Modal.Body> */}
          <Form.Row>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Student Name</Form.Label>
            <Form.Control
              type="text"
              name="name"              
              {...register("name")}
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              disabled={true}
            />
            <span className="invalid-feedback">
              {errors.name?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formLastName"
          >
            <Form.Label className="label">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              {...register("email")}
              disabled={true}
            />
            <span className="invalid-feedback">
              {errors.email?.message}
            </span>
          </Form.Group>
        </Form.Row>    
        <Form.Row>
        <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required form-group required"
            controlId="formLastName"
          >
            <Form.Label className="label">Phone Number</Form.Label>
            <Form.Control
              type="text"
              name="phoneNumber"
              className={`form-control ${errors.phoneNumber ? "is-invalid" : ""}`}
              {...register("phoneNumber")}
              disabled={true}
            />
            <span className="invalid-feedback">
              {errors.phoneNumber?.message}
            </span>
          </Form.Group>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required`}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Branch Name</Form.Label>
            <Controller
                  name="BranchId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchList}
                        className={`${errors.BranchId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        isDisabled={true}
                        // onChange={onBranchChangeAction}
                      />
                      <span className="invalid-feedback">
                        {errors.BranchId?.message}
                      </span>
                    </>
                  )}
                  {...register("BranchId")}
                />
          </Form.Group>
         
        </Form.Row>
        <Form.Row>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Previous ClassGroup</Form.Label>
            <Form.Control
              type="text"
              name="ClassGroupName"              
              {...register("ClassGroupName")}
              className={`form-control ${errors.ClassGroupName ? "is-invalid" : ""}`}
              disabled={true}
            />
            <span className="invalid-feedback">
              {errors.ClassGroupName?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formLastName"
          >
            <Form.Label className="label">Previous  ClassName</Form.Label>
            <Form.Control
              type="text"
              name="ClassRoomName"
              className={`form-control ${errors.ClassRoomName ? "is-invalid" : ""}`}
              {...register("ClassRoomName")}
              disabled={true}
            />
            <span className="invalid-feedback">
              {errors.ClassRoomName?.message}
            </span>
          </Form.Group>
        </Form.Row> 
        <Form.Row>
        <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required form-group"
            controlId="formLastName"
          >
            <Form.Label className="label">Select Class Group Name</Form.Label>
            <Controller
                  name="ClassGroupId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={admissionForwardClassGroups}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        // onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
          </Form.Group>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2  `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Select Class Room Name</Form.Label>
            <Controller
                  name="ClassRoomId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchClassGroupLevelClassRooms}
                        className={`${errors.ClassRoomId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        // onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassRoomId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassRoomId")}
                />
            <span className="invalid-feedback">
              {errors.firstName?.message}
            </span>
          </Form.Group>
          
        </Form.Row>
              
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="bloodGroup"
          >
            <Form.Label className="label">Academic Start Date</Form.Label>
            <Form.Control
              type="date"
              name="academicStartDate"
              className={`form-control ${errors.academicStartDate ? "is-invalid" : ""}`}
              {...register("academicStartDate")}
              // disabled={true}
            />
            <span className="invalid-feedback">
              {errors.academicStartDate?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="admitFor"
          >
            <Form.Label>Academic End Date</Form.Label>
            {/* <DateRangePicker
        ranges={[selectionRange]}
        onChange={handleSelect}
      /> */}
           <Form.Control
              type="date"
              name="academicEndDate"
              className={`form-control ${errors.academicEndDate ? "is-invalid" : ""}`}
              {...register("academicEndDate")}
              // disabled={true}
            />
            <span className="invalid-feedback">
              {errors.academicEndDate?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
            controlId="bloodGroup"
          >
            <Form.Label className="label">Pay for</Form.Label>
            <Form.Control
              type="number"
              name="otherFee"
              className={`form-control ${errors.otherFee ? "is-invalid" : ""}`}
              {...register("otherFee")}
            />
            <span className="invalid-feedback">
              {errors.otherFee?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 "
            controlId="admitFor"
          >
            <Form.Label>Comment</Form.Label>
            {/* <DateRangePicker
        ranges={[selectionRange]}
        onChange={handleSelect}
      /> */}
           <Form.Control
              as="textarea"
              name="comment"
              rows={3}
              //   defaultValue={this.props.inputValues.state}
              //   onChange={this.props.handleChange}
              className={`form-control ${errors.comment ? "is-invalid" : ""}`}
              {...register("comment")}
            >
              
            </Form.Control>
            <span className="invalid-feedback">
              {errors.comment?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
        <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Total Course Fee
              </Form.Label>
              <Col sm="6">
                <Form.Control
                  type="number"
                  name="courseFee"
                  disabled
                  {...register("courseFee")}
                  className={`form-control ${
                    errors.courseFee ? "is-invalid" : ""
                  }`}
                />
                <span className="invalid-feedback">
                  {errors.courseFee?.message}
                </span>
              </Col>
            </Form.Group>
        </Form.Row>
        <div className="spacer"></div>
        <div >
          <Button
            variant="btn app-default-button btn btn-primary"
            type="submit"
          >
            Submit
          </Button>
        </div>
        {/* <Form.Row> */}
        {/* </Form.Row>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Select Branch Name
              </Form.Label>
              <Col sm="6">
                <Controller
                  name="BranchId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchList}
                        className={`${errors.BranchId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        isDisabled={true}
                        // onChange={onBranchChangeAction}
                      />
                      <span className="invalid-feedback">
                        {errors.BranchId?.message}
                      </span>
                    </>
                  )}
                  {...register("BranchId")}
                />
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Select Class Group Name
              </Form.Label>
              <Col sm="6">
                {" "}
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={classGroupList}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Select Class Name
              </Form.Label>
              <Col sm="6">
                {" "}
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={classRoomList}
                        className={`${errors.ClassRoomId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        // onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassRoomId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassRoomId")}
                />
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3 required"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Total Course Fee
              </Form.Label>
              <Col sm="6">
                <Form.Control
                  type="number"
                  name="courseFee"
                  disabled
                  {...register("courseFee")}
                  className={`form-control ${
                    errors.courseFee ? "is-invalid" : ""
                  }`}
                />
                <span className="invalid-feedback">
                  {errors.courseFee?.message}
                </span>
              </Col>
            </Form.Group> */}
          {/* </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer> */}
        </Form>
      {/* </Modal> */}
    </>
  );
};

export default AdmissionForward;
